import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import OrderCard from '../order/OrderCard'
import {DeliveryListRequest, AcceptRejectRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
import { IMAGE } from '../../utils/Theme'

const UpcomingDelivery = () => {


  const fetchReducer = useSelector((state) => state.FetchDataReducer)
 
  const dispatch = useDispatch()


useEffect(()=>{
  let obj = {
    'status':'upcoming'
  }

  dispatch(DeliveryListRequest(obj))

},[])

const AcceptHandle = (uuid, status)=>{

  let obj= {
    "uuid": uuid,
    "status": status,
    "comment":status ? "I have accepted the order" : "I have rejected the order"
  }
  dispatch(AcceptRejectRequest(obj))
}


  return (
    <>
    <Loader visible={fetchReducer.isloading} />
     {fetchReducer?.deliveryResponse?.data
&&fetchReducer?.deliveryResponse?.data.length > 0 ?
fetchReducer?.deliveryResponse?.data&&fetchReducer?.deliveryResponse?.data.map((item, index) =>{
         if(!item?.status){
           return (
             <div className='order-card' key={index}>
           
             <div className='order-card-header'>
                 <div className='order-card-header-sl'>
                     {index + 1}
                 </div>
                 <div className='order-card-header-info'>
                     <h5>Order: <span>{item?.order?.order_no
}</span></h5>
                     <h5>Order Amt: <span>${item?.order?.total}</span></h5>
                 </div>
             </div>
             <div className='order-card-body'>
                 <div className='b-plist'>
                     <span>
                         <img src={IMAGE.location}/>
                     </span>
                     <p>{item?.order?.address}</p>
                 </div>
                 <div className='b-plist'>
                     <span>
                         <img src={IMAGE.user}/>
                     </span>
                     <p>Delivery To: {item?.order?.name}</p>
                 </div>
                 <ul>
                          <li>
                              <button className='reject-btn' onClick={()=>AcceptHandle(item?.order?.uuid, false)}>Reject</button>
                          </li>
                          <li>
                              <button className='accept-btn' onClick={()=>AcceptHandle(item?.order?.uuid, true)}>Accept</button>
                          </li>
                      </ul>
             </div>
          
         </div>
           )
         }
          
         }) 
       : 

       <h5>No Upcoming Deliveries</h5>
       
       }
   </>
  )
}

export default UpcomingDelivery